import { z } from 'zod';

export type Credential = z.infer<typeof credentialSchema>;
export const credentialSchema = z.object({
  id: z.string(),
  label: z.string(),
  createdDate: z.number(),
  type: z.string().nullish(),
});

export type CredentialsData = z.infer<typeof credentialsDataSchema>;
export const credentialsDataSchema = z.object({
  otp: z.object({
    configured: z.boolean(),
    credentials: z.array(credentialSchema),
  }),
  passkeys: z.object({
    configured: z.boolean(),
    credentials: z.array(credentialSchema),
  }),
  actions: z.object({
    createPasskeyUrl: z.string(),
    createPasskeyPasswordlessUrl: z.string(),
    configureOtpUrl: z.string(),
    updatePasswordUrl: z.string(),
  }),
});
